const styles = theme => ({
    root: {
        fontWeight: 600,
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1),
    },
    required: {
        color: theme.palette.error.main
    }
});

export default styles;